import { useEffect, useState } from 'react';
import { useFormContext } from 'shared-widget-components/src/providers/FormContextProvider';
import { WinePackageModel, WinePackageWidgetModel } from '../../../models/WinePackageWidgetModel';
import { PackageTypes } from 'shared-widget-components/src/constants/Constants';
import useAsyncEffect from 'use-async-effect';
import { fetchPackagesForPreview } from '../../../services/PackagePreviewService';
import { isEqual } from 'lodash';

export const useWidgetBody = (data: string, productVariantIds: number[], buttonColor?: string, buttonTextColor?: string, primaryColor?: string, featuredPackages?: WinePackageWidgetModel[]) => {
  const [isValidationError, setIsValidationError] = useState(false);

  const showErrorMessage = () => {
    setIsValidationError(true);
    setTimeout(() => {
      setIsValidationError(false);
    }, 2000);
  };

  //@ts-ignore
  const languageCode = window.currentLanguageCode;

  const { reset } = useFormContext();

  useEffect(() => {
    if (data) return;
    reset({ type: 'FEATURED' } as WinePackageModel);
  }, []);

  useEffect(() => {
    if (data) {
      const parsedData: WinePackageModel = JSON.parse(data);
      const productVariantIdList = featuredPackages?.map((item) => item.productVariantId);
      reset({
        widgetTitle: parsedData.widgetTitle ?? { hu: { title: '' } },
        backgroundColor: parsedData.backgroundColor ?? primaryColor,
        textColor: parsedData.textColor ?? buttonTextColor,
        type: parsedData.type ?? PackageTypes.FEATURED,
        packages: parsedData.packages ?? productVariantIdList,
        renderedPackages: parsedData.renderedPackages ?? 5,
        scrollbarColor: parsedData.scrollbarColor ?? buttonColor,
      });
    }
  }, [data, buttonColor, buttonTextColor, primaryColor, featuredPackages]);

  const [winePackageList, setWinePackageList] = useState<WinePackageWidgetModel[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useAsyncEffect(async () => {
    if (!productVariantIds || productVariantIds?.length === 0) {
      setWinePackageList([]);
      return;
    }
    const areArraysEqual = isEqual(
      productVariantIds,
      winePackageList.map((item) => item.productVariantId),
    );

    if (areArraysEqual || isLoading) return;
    setIsLoading(true);
    try {
      const winePackageDatas = await fetchPackagesForPreview(productVariantIds);
      const reorderedWinePackageDatas = productVariantIds.map((winePackageId: number) => winePackageDatas.find((winePackage: WinePackageWidgetModel) => winePackage.productVariantId === winePackageId));
      setWinePackageList(reorderedWinePackageDatas);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      throw new Error(error);
    }
  }, [productVariantIds]);

  return { languageCode, isValidationError, showErrorMessage, winePackageList, isLoading };
};
